import React from 'react';
import { Box } from 'rebass';

/**
 * Similar to `components/ContentContainer` but used for blog content
 */
const BlogContentContainer = (props) => (
  <Box
    mx="auto"
    px={[4, , 5]}
    maxWidth="700px"
    width="100%"
    sx={{ boxSizing: 'border-box' }}
    {...props}
  />
);

export default BlogContentContainer;
